export const GET_SMS_COUNT_REMAIN = "GET_SMS_COUNT_REMAIN";
export const GET_SMS_RELOAD_HISTORY = "GET_SMS_RELOAD_HISTORY";
export const GET_SMS_COUNT = "GET_SMS_COUNT";